<script>
export default {
  name: "DeviceCommentSaveModal",
  props: {
    isModalActive: Boolean,
    deviceId: [Number, String],
    editingComment: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        title: "",
        text: "",
        date: new Date()
      },
      errors: { },
      isSaving: false,
    }
  },
  computed: {
    isEditing() {
      return !!this.editingComment
    },
    modalTitle() {
      return this.isEditing ? "Редактировать событие" : "Добавить событие"
    },
    submitButtonText() {
      return this.isEditing ? "Сохранить" : "Добавить"
    }
  },
  watch: {
    editingComment: {
      handler(newComment) {
        if (newComment) {
          this.form.title = newComment.title || ""
          this.form.text = newComment.text || ""
          this.form.date = new Date(newComment.date) || ""
        }
      },
      immediate: true
    },
    isModalActive(isActive) {
      if (isActive && !this.isEditing) {
        this.form.text = ""
      }
    }
  },
  methods: {
    async submitComment() {
      this.isSaving = true
      try {
        if (this.isEditing) {
          await this.$axios.put(`user/commentaries/${this.editingComment.id}`, {
            agent_id: this.deviceId,
            ...this.form
          })
        } else {
          await this.$axios.post("user/commentaries", {
            agent_id: this.deviceId,
            ...this.form
          })
        }
        this.onModalClose()
        this.$emit("refresh")
      } catch (e) {
        console.error(e)
        this.errors = e.error?.response.data.errors || { }
        console.log(this.errors)
        throw e
      } finally {
        this.isSaving = false
      }
    },
    onModalClose() {
      this.form.title = ''
      this.form.text = ''
      this.$emit("update:isModalActive", false)
      this.$emit("update:editingComment", null)
    }
  },
}
</script>

<template>
  <b-modal :active="isModalActive" :width="640" scroll="keep" :can-cancel="false" :animation="null" @close="onModalClose">
    <div class="box">
      <h1 class="title is-5">{{ modalTitle }}</h1>

      <b-field
        :type="!!errors.title ? 'is-danger' : 'text'"
        :message="errors.title"
      >
        <b-input
          v-model="form.title"
          type="text"
          name="title"
          placeholder="Заголовок"
          maxlength="50"
        ></b-input>
      </b-field>
      <b-field
        :type="!!errors.text ? 'is-danger' : 'text'"
        :message="errors.text"
      >
        <b-input
          v-model="form.text"
          type="textarea"
          name="text"
          placeholder="Описание"
          rows="5"
          maxlength="255"
        ></b-input>
      </b-field>
      <b-field
        :type="!!errors.date ? 'is-danger' : 'text'"
        :message="errors.date"
        label="Дата проведения ТО"
      >
        <b-datepicker
          v-model="form.date"
          append-to-body
          locale="ru-RU"
          position="is-top-right"
          name="date"
          placeholder="Дата события"
          :first-day-of-week="1"
        ></b-datepicker>
      </b-field>

      <div class="is-flex is-justify-content-right mt-5" style="gap: 8px">
        <b-button @click="onModalClose">Отмена</b-button>
        <b-button
          type="is-info"
          :disabled="!form.title || !form.text"
          :loading="isSaving"
          @click="submitComment"
        >
          {{ submitButtonText }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>

</style>
